const defaultProps = {
  centerRipple: false,
  size: 'medium' as const,
};

export default defaultProps;
